import { faX } from "@fortawesome/free-solid-svg-icons";
import { BaseLogo } from "../../../core/models/entities/BaseLogo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

export type LogoDimensionFormat =
  | "BWWXHYYMM"
  | "WWxYYmm"
  | "HYYmmMWXXmm"
  | "HYYmm";

export function LogoDimensions({
  logo,
  format: format = "BWWXHYYMM",
}: {
  logo: BaseLogo;
  format?: LogoDimensionFormat;
}) {
  const { t } = useTranslation();
  switch (format) {
    case "BWWXHYYMM":
      return (
        <span>
          <b>{t("compLogoDesign.widthShort")}</b> {logo.widthMm} x{" "}
          <b>{t("compLogoDesign.heightShort")}</b> {logo.heightMm} MM
        </span>
      );

    case "WWxYYmm":
      return (
        <span>
          {logo.widthMm}x{logo.heightMm}mm
        </span>
      );

    case "HYYmmMWXXmm":
      return (
        <span>
          <b>{t("compLogoDesign.height")}</b> {logo.heightMm}mm <br />{" "}
          <b>{t("compLogoDesign.maxWidth")}</b> {logo.widthMm}
          mm
        </span>
      );

    case "HYYmm":
      return (
        <span>
          <b>{t("compLogoDesign.height")}</b> {logo.heightMm}mm
        </span>
      );
  }
}
